import { useTranslation } from "react-i18next";
import { DIAGNOSTIC_STEP_GENERAL_RECOMMENDATIONS_KEY, DIAGNOSTIC_STEP_PERMISSION_VALUE } from "@/constants/diagnostics";
import { setDiagnosticsStep } from "@/store/features/diagnostics/slice";
import { useAppDispatch } from "@/store/hooks";
import { Button } from "@/ui";
import DiagnosticsSection from "../DiagnosticsSection";

const items = new Array(6).fill(0);

const GeneralRecommendations = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const onClickLetSetUp = () => {
    dispatch(setDiagnosticsStep(DIAGNOSTIC_STEP_PERMISSION_VALUE));
  };

  return (
    <DiagnosticsSection id={DIAGNOSTIC_STEP_GENERAL_RECOMMENDATIONS_KEY}>
      <div className="section-wrapper">
        <div className="section-content">
          <h2>{t('general_recommendations')}</h2>
          <ul>
            {items.map((_, index) => (
              <li key={index}>
                <p>{t(`general_recommendations_${index + 1}`)}</p>
              </li>
            ))}
          </ul>
          <Button onClick={onClickLetSetUp}>
            {t('let_s_set_up')}
          </Button>
        </div>
        <div className="section-image hidden-sm">
          <img src="/images/recommendations.webp" alt={t('general_recommendations')} />
        </div>
      </div>
    </DiagnosticsSection>
  );
};

export default GeneralRecommendations;